module.exports = __webpack_public_path__ + "WebComponentsIcons.b6d197fe6d7866159412.svg";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/glyphs/WebComponentsIcons.svg?gedxeo
// module id = ../../../../../external_css/kendo-ui/fonts/glyphs/WebComponentsIcons.svg?gedxeo
// module chunks = styles